import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import spread from "../../images/svg/spread.svg";
import { getUyeItemData } from "../../features/uyelerAraclar/uyelerAraclarSlice";
import { showModal } from "../../features/modal/modalSlice";
import { useDispatch } from "react-redux";
import { getUETDSItemData } from "../../features/admin/adminSlice";
import moment from "moment";
import { setSelectRentalCar } from "../../features/ilanlar/ilanlarSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  background-color: ${({ theme }) => theme.secondaryBgColor};
  cursor: pointer;
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px !important;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: var(--color-light);
      .row {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-sm);
          width: 120px;
        }
      }
    }
  }
`;

const KiralikAracArayanFirmalarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const dispatch = useDispatch();

  return (
    <Container onClick={() => {dispatch(showModal("rentalCarSeekerOptions")); dispatch(setSelectRentalCar(data))}} theme={theme}>
      <div className="container">
        <div className="content">
          <div className="row">
            <div className="col">{data.id}</div>
            <div className="col">{moment(data.createdAt).format("DD.MM.YYYY")}</div>
            <div className="col">{data.vehicleCount}</div>
            <div className="col">{data.vehicleType ? data.vehicleType : "-"}</div>
            <div className="col">{data.bodyType ? data.bodyType : "-"}</div>
            <div className="col">{data?.rentVehicleNewWorkCities.$values.map((item, i) => {
              return `${item.city}${i+1 !== data?.rentVehicleNewWorkCities.$values.length ? ", " : ""}`
            })}</div>
            <div className="col">{data.workRoute ? data.workRoute : "-"}</div>
            <div className="col">{data.fuelPercentage ? data.fuelPercentage : "-"}</div>
            <div className="col">{data.rentalPrice ? data.rentalPrice : "-"}</div>
            <div className="col">{(data.contractDuration && `${data.contractDuration} Ay`) || "-"}</div>
            <div className="col">{data.advertOwner}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default KiralikAracArayanFirmalarContainer;
